import { CustomerAccountApi } from '@ariksa/data-scanning/api';
import { DefaultApi, ItemApi } from '@ariksa/scan-analysis';

import { BASE_URL } from '../service_urls';

import { TokenConfig } from './TokenCredential';

/** Compatibility-only clients for flag-off paths not yet migrated. */
const config = new TokenConfig();

export const LegacyScanAnalysis = {
  Item: new ItemApi(config, BASE_URL),
  Default: new DefaultApi(config, BASE_URL),
  Customer: new CustomerAccountApi(config, BASE_URL),
};
